import React from 'react';
import { siteContent } from '../data/mock';

const Proof = () => {
  const { proof } = siteContent;

  return (
    <section className="py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-medium text-neutral-900 mb-12">
          {proof.title}
        </h2>
        <div className="space-y-6 text-lg text-neutral-700 leading-relaxed">
          {proof.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
        </div>
      </div>
    </section>
  );
};

export default Proof;
